import { useQuery } from "@tanstack/react-query";
import { getAuthorCoupons } from "src/api/coupon";
/** API 응답을 CouponDownloadItemData 형태로 변환 */ const transformToCouponDownloadItem = (item)=>{
    // 유효기간 텍스트 생성
    const getExpiredText = ()=>{
        if (item.expiredAfterDay !== undefined) {
            return "다운로드 후 ".concat(item.expiredAfterDay, "일 이내");
        }
        if (item.expiredDate) {
            return "".concat(item.expiredDate, "까지");
        }
        return "";
    };
    var _item_hasBeenReceived;
    return {
        id: item.id,
        name: item.title,
        discountMaximumPriceText: item.discountMaximumPriceText,
        minimumPriceText: item.minimumPriceText,
        expiredText: getExpiredText(),
        isDownloaded: (_item_hasBeenReceived = item.hasBeenReceived) !== null && _item_hasBeenReceived !== void 0 ? _item_hasBeenReceived : false
    };
};
export const useAuthorCouponsQuery = (param)=>{
    let { authorId , enabled =true  } = param;
    return useQuery({
        queryKey: [
            "authorCoupons",
            authorId
        ],
        queryFn: ()=>getAuthorCoupons(authorId),
        enabled: enabled && !!authorId,
        select: (data)=>({
                count: data.count,
                coupons: data.items.map(transformToCouponDownloadItem)
            })
    });
};
